import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Edit, Trash2, User, Shield, Wrench, Search } from 'lucide-react';
import { users as usersData, centres } from '../../data/mockData';

function ListeUtilisateurs({ user }) {
  const [users, setUsers] = useState(usersData);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRole, setFilterRole] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });

  // Vérifier que l'utilisateur est admin
  if (user.role !== 'admin') {
    return (
      <div className="page-container">
        <div className="alert alert-error">
          Vous n'avez pas accès à cette page.
        </div>
      </div>
    );
  }

  const filteredUsers = users.filter(u => {
    const matchSearch = 
      u.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.prenom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.username.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchRole = !filterRole || u.role === filterRole;
    
    return matchSearch && matchRole;
  });

  const handleDelete = (userId) => {
    if (userId === user.id) {
      setMessage({ type: 'error', text: 'Vous ne pouvez pas supprimer votre propre compte.' });
      return;
    }
    
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet utilisateur ?')) {
      setUsers(users.filter(u => u.id !== userId));
      setMessage({ type: 'success', text: 'Utilisateur supprimé avec succès.' });
    }
  };

  const getCentreName = (centreId) => {
    const centre = centres.find(c => c.id === centreId);
    return centre ? centre.nom : '-';
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Gestion des utilisateurs</h1>
          <p className="text-muted">Gérer les comptes administrateurs et techniciens</p>
        </div>
        <Link to="/utilisateurs/nouveau" className="btn btn-primary">
          <Plus size={20} />
          Nouvel utilisateur
        </Link>
      </div>

      {message.text && (
        <div className={`alert alert-${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="filters-bar">
        <div className="search-input-group">
          <Search size={20} className="search-icon" />
          <input
            type="text"
            placeholder="Rechercher par nom, prénom, email..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        <select
          value={filterRole}
          onChange={(e) => setFilterRole(e.target.value)}
          className="filter-select"
        >
          <option value="">Tous les rôles</option>
          <option value="admin">Administrateurs</option>
          <option value="technicien">Techniciens</option>
        </select>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Utilisateur</th>
              <th>Identifiant</th>
              <th>Email</th>
              <th>Rôle</th>
              <th>Centre</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center text-muted">
                  Aucun utilisateur trouvé
                </td>
              </tr>
            ) : (
              filteredUsers.map(u => (
                <tr key={u.id}>
                  <td>
                    <div className="user-cell">
                      <div className="user-avatar user-avatar-sm">
                        {u.prenom[0]}{u.nom[0]}
                      </div>
                      <div>
                        <strong>{u.prenom} {u.nom}</strong>
                        <br />
                        <span className="text-muted text-sm">{u.telephone}</span>
                      </div>
                    </div>
                  </td>
                  <td><code>{u.username}</code></td>
                  <td>{u.email}</td>
                  <td>
                    <span className={`badge ${u.role === 'admin' ? 'badge-warning' : 'badge-primary'}`}>
                      {u.role === 'admin' ? (
                        <><Shield size={12} /> Administrateur</>
                      ) : (
                        <><Wrench size={12} /> Technicien</>
                      )}
                    </span>
                  </td>
                  <td>{u.role === 'technicien' ? getCentreName(u.centreId) : '-'}</td>
                  <td>
                    <div className="actions-group">
                      <Link 
                        to={`/utilisateurs/${u.id}/modifier`}
                        className="btn btn-sm btn-secondary"
                      >
                        <Edit size={16} />
                      </Link>
                      <button 
                        onClick={() => handleDelete(u.id)}
                        className="btn btn-sm btn-danger"
                        disabled={u.id === user.id}
                        title={u.id === user.id ? "Vous ne pouvez pas supprimer votre propre compte" : "Supprimer"}
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ListeUtilisateurs;

